import { Checkbox, CheckboxProps } from '@mui/material';
import { FC } from 'react';

const disabledOverride = {
  '&.Mui-disabled': {
    opacity: 0.48,
    color: '#6F4290 !important',
  },
};

const CustomCheckbox: FC<CheckboxProps> = (props) => {
  const { sx, ...restProps } = props;

  return <Checkbox sx={{ ...disabledOverride, ...sx }} {...restProps} />;
};

export default CustomCheckbox;
